import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "bg-gray-200" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  class: "loading-info",
  colspan: "1000"
}
const _hoisted_5 = { class: "loading-info__content" }
const _hoisted_6 = { class: "loading-info__title" }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = {
  class: "no-data",
  colspan: "1000"
}
const _hoisted_9 = { key: 2 }
const _hoisted_10 = {
  class: "error",
  colspan: "1000"
}
const _hoisted_11 = { key: 0 }
const _hoisted_12 = {
  colspan: "1000",
  class: "trash-bin-all-selected__content"
}
const _hoisted_13 = {
  class: "add-partial-delivery",
  colspan: 1000
}
const _hoisted_14 = { class: "add-partial-delivery__container" }
const _hoisted_15 = ["onClick"]

import { i18n } from '@/i18n';
import SimpleCard from '@/components/atom/SimpleCard.vue';
import { computed, nextTick, onBeforeUnmount, ref, watch } from 'vue';
import { onMounted } from 'vue';
import { IDisplayObject, TableProperty, TableType, isCommonTableHeaderKey } from '@/coreDomainsModule/table';
import { TableContentViewModel } from '@/viewModels/tableContent';
import { useBaseTableContentStore } from './useBaseTableContentStore';
import { storeToRefs } from 'pinia';
import { TableContentItem } from './interface/tableContentItems';
import { BaseTableContentViewModel } from './baseTableContentViewModel';
import {
  TableContentHeader,
  TableContentProperty,
  isBusinessesForSupplierForecastHeaderKey,
  isForecastForReceiptKey,
  isForecastAccuracyKey,
  isOrderControlHeaderKey,
  isOrderHeaderKey,
  isUniqueHeaderKey,
  isUnmanagedBusinessHeaderKey,
  isTrashBinHeaderKey,
  isMoveWareHouseHeaderKey,
  OrderHeaderKey,
} from '@/corePagesModule/BaseTableContent/interface/tableContentHeaders';
import { MAX_COLUMN_WIDTH, MIN_COLUMN_WIDTH, STICKY_COLUMN_WIDTH } from './constants';
import { ResizeStateService } from './services/resizeStateService';
import OrderTableHead from './components/order/OrderTableHead.vue';
import OrderTableCell from './components/order/OrderTableCell.vue';
import CommonTableHead from './components/CommonTableHead.vue';
import CommonTableCell from './components/CommonTableCell.vue';
import UniqueTableHead from './components/unique/UniqueTableHead.vue';
import UniqueTableCell from './components/unique/UniqueTableCell.vue';
import UnmanagedBusinessTableCell from './components/unmanagedBusiness/UnmanagedBusinessTableCell.vue';
import UnmanagedBusinessTableHead from './components/unmanagedBusiness/UnmanagedBusinessTableHead.vue';
import { NarrowState } from './interface/uiState';
import BusinessesForSupplierForecastTableHead from './components/businessesForSupplierForecast/BusinessesForSupplierForecastTableHead.vue';
import BusinessesForSupplierForecastTableCell from './components/businessesForSupplierForecast/BusinessesForSupplierForecastTableCell.vue';
import { LoadingState, isError, isLoading, isZeroMatch } from '@/coreDomainsModule/uiLoadingState';
import OrderControlTableCell from './components/orderControl/OrderControlTableCell.vue';
import OrderControlTableHead from './components/orderControl/OrderControlTableHead.vue';
import { LottieAnimation } from 'lottie-web-vue';
import loadingAnimation from '@/assets/loadingAnimation.json';
import SvgLoader from '@/utils/SvgLoader.vue';
import TrashBinTableHead from './components/trashBin/TrashBinTableHead.vue';
import TrashBinTableCell from './components/trashBin/TrashBinTableCell.vue';
import MoveWarehouseTableCell from './components/moveWarehouse/moveWarehouseTableCell.vue';
import CustomerForecastTableHeaderWrapper from './components/customerForecast/CustomerForecastTableHeaderWrapper.vue';
import CustomerForecastTableCellWrapper from './components/customerForecast/CustomerForecastTableCellWrapper.vue';
import ForecastAccuracyTableHead from './components/customerForecast/ForecastAccuracyTableHead.vue';
import ForecastAccuracyTableCell from './components/customerForecast/ForecastAccuracyTableCell.vue';
import { Order } from '@/coreDomainsModule/entities/order';
import { PartialDelivery } from '@/coreDomainsModule/entities/partialDelivery';
import TableCell from './components/TableCell.vue';

/**
 * LEANPATHで使うテーブルの大元のコンポーネント
 * もしtemplate部分が肥大化しそうになったら、v-if以下をコンポーネント化することを検討する
 */

// props

export default /*@__PURE__*/_defineComponent({
  __name: 'NewBaseTableContent',
  props: {
    propTableContentProperties: {},
    propDisplayObjects: { default: undefined },
    propLoadingStatus: {},
    propTableType: {},
    propIsEditing: { type: Boolean, default: false },
    propIsReset: { type: Boolean, default: false },
    propTableId: { default: '' },
    propAllOfResult: { default: undefined },
    propCheckedIds: { default: undefined },
    propIsAllSelected: { type: Boolean, default: false },
    propEditingId: { default: '' }
  },
  emits: ["submit", "complete", "open-excel-output-modal", "checked", "onClickVariableContent", "onClickSort", "onClickFilter", "reload", "onClickTrashBinAllSelect", "onClickTransitionTimeline", "onClickEdit", "onClickSave", "onChangeOrderProperty", "onChangePartialDelivery", "onClickDelete", "onClickAddPartialDelivery", "onClickSaveMemo", "onClickDeleteMemo", "onClickReminderMail", "onClickOrderBasis", "onClickDownload", "onClickTransactionList", "onClickForecastRequestMail", "onClickRemoveFromForecast"],
  setup(__props: any, { emit: __emit }) {

_useCssVars(_ctx => ({
  "c1303442": (computedColumnWidths.value.join(" ")),
  "56aac160": (`${_unref(MAX_COLUMN_WIDTH)}px`),
  "51be8938": (`${partialDeliveryAddLineWidth.value}px`),
  "7cac34ba": (`${partialDeliveryAddLineRight.value}px`)
}))

const props = __props;

// emits
const emits = __emit;

//変数
const t = i18n.t;
const vm = new TableContentViewModel();
const baseTableContentVM = new BaseTableContentViewModel();
const store = useBaseTableContentStore(props.propTableType + props.propTableId)();
const { state } = storeToRefs(store);

const partialDeliveryAddLineWidth = ref(0);
const partialDeliveryAddLineRight = ref(0);

const {
  $reset,
  initializeTableContent,
  synchronizeTableContentProperties,
  selectAllLines,
  selectAllLinesForOrder,
  setNarrowState,
  onSelectedLine,
  getModifiableHeaderList,
  onToggleDisplayHeader,
  selectAllLinesForBusinessId,
  onSelectedLineForBusinessId,
} = store;

onMounted(async () => {
  if (props.propDisplayObjects === undefined) return; // TODO: 例外処理
  $reset();
  window.addEventListener('scroll', closeAlert);
  initializeTableContent(
    props.propTableContentProperties,
    props.propDisplayObjects,
    props.propLoadingStatus,
    props.propTableType,
    props.propIsEditing
  );
});

onBeforeUnmount(() => {
  window.removeEventListener('scroll', closeAlert);
});

const useTableHeader = computed((): TableContentProperty[] => {
  if (state.value?.tableContentProperties === undefined) return [];
  return state.value.tableContentProperties.contentProperties;
});

const useItems = computed((): TableContentItem[] => {
  if (state.value?.items === undefined) return [];
  return state.value.items;
});

/**
 * テーブルの列幅をヘッダー順に並べた配列を返す
 */
const computedColumnWidths = computed((): string[] => {
  if (!state?.value?.tableContentProperties?.contentProperties) return [];
  return state.value.tableContentProperties.contentProperties.map((contentProperty, index) => {
    // 固定幅
    if (baseTableContentVM.isSticky(state.value.tableContentProperties.options.stableColumnCount, index)) {
      return contentProperty.headerWidth ? `${contentProperty.headerWidth}px` : `${STICKY_COLUMN_WIDTH}px`;
    }
    // 列幅を明示的に指定していない場合はmax-contentで調整されるようにする
    if (!contentProperty.headerWidth) return 'minmax(max-content, 1fr)';
    if (!contentProperty.isVariableWidth) return `${contentProperty.headerWidth}px`;
    const width = baseTableContentVM.clampedTableColumnWidth(contentProperty.headerWidth);
    // リサイズ中の列
    if (state.value.resizeState.resizingIndex === index) {
      return `${width}px`;
    }
    return `minmax(${width}px, ${width}fr)`;
  });
});

/**
 * OrderEstimateTimeOfArrivalヘッダーの左端がテーブルの右端からどれぐらいのWidthなのかを測る
 * @returns - Width
 */
const measurePartialDeliveryAddLineWidthMethod = (): [number, number] => {
  const table = document.getElementById(ResizeStateService.getTableContentId(props.propTableType));
  if (!table) {
    return [0, 0];
  }

  const startHeader = table.querySelector('th[data-key="OrderDeleteButton"]');
  if (!startHeader) {
    return [0, 0];
  }

  const endHeader = table.querySelector('th[data-key="OrderEditButton"]');
  if (!endHeader) {
    return [0, 0];
  }

  const tableRect = table.getBoundingClientRect();
  const startHeaderRect = startHeader.getBoundingClientRect();
  const endHeaderRect = endHeader.getBoundingClientRect();

  const width = endHeaderRect.right - startHeaderRect.left;
  const right = tableRect.right - endHeaderRect.right;
  return [width, right];
};

watch(
  () => props.propLoadingStatus,
  () => {
    state.value.loadingState = props.propLoadingStatus;
  }
);

watch(
  () => props.propIsEditing,
  () => {
    state.value.isEditing = props.propIsEditing;
  }
);

watch(
  () => [props.propDisplayObjects, props.propEditingId],

  async () => {
    if (props.propDisplayObjects) {
      state.value.items = props.propDisplayObjects;
    }
    if (props.propTableType === 'firmOrderTable') {
      await nextTick();
      [partialDeliveryAddLineWidth.value, partialDeliveryAddLineRight.value] = measurePartialDeliveryAddLineWidthMethod();
    }
  },
  { deep: true }
);

watch(
  () => props.propIsReset,
  (newVal) => {
    if (newVal) {
      $reset();

      initializeTableContent(
        props.propTableContentProperties,
        props.propDisplayObjects ?? [],
        props.propLoadingStatus,
        props.propTableType,
        props.propIsEditing
      );
    }
  }
);

watch(
  () => props.propIsAllSelected,
  (val) => {
    if (val) {
      state.value.selectedIds = props.propCheckedIds ?? [];
    }
  }
);

watch(
  () => props.propTableContentProperties.contentProperties,
  async (newContentProperties) => {
    await synchronizeTableContentProperties(newContentProperties);
  }
);

/**
 * リサイザーのマウスダウンイベント
 * @param event - マウスイベント
 * @param index - インデックス
 */
const onMouseDownResizer = (event: MouseEvent, index: number) => {
  store.onMouseDownResizer(event, index);
};

/**
 * アラートを閉じる処理
 */
const closeAlert = () => {
  state.value.isOpeningAlertIndex = '';
};

/**
 * チェックボックス
 * @param displayId - 表示ID
 * @param isAll - 全選択
 */
const onCheckboxSelectedWrapper = (displayId: string, isAll = false) => {
  if (isAll) {
    selectAllLines(useItems.value);
  } else {
    onSelectedLine(displayId);
  }
  emits('checked', state.value.selectedIds); // onSelectedLineの結果を親コンポーネントに通知
};

/**
 * businessIdのチェックボックス
 * @param businessId - 取引ID
 * @param isAllSelected - 全選択
 * @param isAllClear - 全解除
 */
const onCheckboxSelectedBusinessId = (businessId: string, isAllSelected?: boolean, isAllClear?: boolean) => {
  if (isAllSelected !== undefined && isAllSelected) {
    selectAllLinesForBusinessId(useItems.value);
  } else if (isAllClear !== undefined && isAllClear) {
    state.value.isAllSelected = false;
    state.value.selectedIds = [];
  } else {
    onSelectedLineForBusinessId(businessId);
  }

  emits('checked', state.value.selectedIds); // onSelectedLineの結果を親コンポーネントに通知
};

/**
 * 発注むけのチェックボックス
 * @param displayId - 表示ID
 * @param isAll - 全選択
 */
const onCheckboxSelectedWrapperForOrderControl = (displayId: string, isAll = false) => {
  if (isAll) {
    selectAllLinesForOrder(useItems.value);
  } else {
    onSelectedLine(displayId);
  }
  emits('checked', state.value.selectedIds); // onSelectedLineの結果を親コンポーネントに通知
};

/**
 * テーブルの内容をソートする
 * @param index - インデックス
 * @param key - キー
 * @param isAsc - 昇順
 */
const sortTableContentItemsWrapper = async (index: number, key: TableContentProperty, isAsc: boolean) => {
  // selectedIdsが存在する場合、checkboxを全解除する
  if (state.value.selectedIds.length > 0) {
    state.value.isAllSelected = false;
    state.value.selectedIds = [];
    emits('checked', state.value.selectedIds); // onSelectedLineの結果を親コンポーネントに通知
  }
  emits('onClickSort', key, !isAsc);
  // ソートの矢印を切り変える
  state.value.tableContentProperties.contentProperties[index].sortOption.isAsc = !isAsc;
};

/**
 * narrowStateを発火させる
 * @param key - 絞り込むヘッダーのキー
 * @param value - 絞り込む値
 */
const setNarrowStateWrapper = async (key: TableContentProperty, value?: string | number) => {
  // TODO: valueを現状、itemから単純にキー指定で取得しているが、viewModelでパターン網羅して取得するように修正する（orderCellとかひとつも取れていない）

  // selectedIdsが存在する場合、checkboxを全解除する
  if (state.value.selectedIds.length > 0) {
    state.value.isAllSelected = false;
    state.value.selectedIds = [];
    emits('checked', state.value.selectedIds); // onSelectedLineの結果を親コンポーネントに通知
  }
  setNarrowState(key, value);
  emits('onClickFilter', state.value.narrowStates);
};

/**
 * itemが分納を持っているかどうかを判定する
 * @param item - テーブルのアイテム
 */
const hasPartialDelivery = (item: TableContentItem): boolean => {
  const order = item as Order;
  return order.partialDeliveries !== undefined;
};

/**
 * itemのbusinessId or aggregateBusinessIdがテーブルでチェックされた取引に含まれているかを判定する
 * @param item - テーブルのアイテム
 */
const isCheckedBusinessId = (item: TableContentItem) => {
  return state.value.selectedIds.includes(item?.businessId ?? item?.aggregateBusinessId);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SimpleCard, {
    id: _unref(ResizeStateService).getTableContainerId(_ctx.propTableType),
    class: "base-table-wrapper",
    onScroll: closeAlert
  }, {
    default: _withCtx(() => [
      _createElementVNode("table", {
        id: _unref(ResizeStateService).getTableContentId(_ctx.propTableType),
        class: "mb-2 base-table"
      }, [
        _createElementVNode("thead", _hoisted_2, [
          _createElementVNode("tr", {
            style: _normalizeStyle({ userSelect: _unref(state).resizeState.resizingIndex !== -1 ? 'none' : 'auto' })
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(useTableHeader.value, (header, headerIndex) => {
              return (_openBlock(), _createElementBlock(_Fragment, {
                key: `${_ctx.propTableType}-header-` + headerIndex
              }, [
                (_unref(isCommonTableHeaderKey)(header.key))
                  ? (_openBlock(), _createBlock(CommonTableHead, {
                      key: headerIndex,
                      header: header,
                      "header-index": headerIndex,
                      "accumulation-table-content-width": _unref(state).accumulationTableContentWidth,
                      "is-variable-width": header.isVariableWidth,
                      "stable-column-count": _unref(state).tableContentProperties.options.stableColumnCount,
                      "is-editing": _unref(state).isEditing,
                      "is-bold": _unref(baseTableContentVM).isBold(_unref(state).narrowStates, header?.propertyPath?.paths),
                      "is-all-selected": _unref(state).isAllSelected,
                      "modifiable-header-list": _unref(getModifiableHeaderList)(_ctx.propTableType, _ctx.propTableContentProperties),
                      "is-open-header-modify-button-menu": _unref(state).isOpenHeaderModifyButtonMenu,
                      "table-type": _ctx.propTableType,
                      onOnClickSort: sortTableContentItemsWrapper,
                      onOnMousedownResizer: onMouseDownResizer,
                      onOnCheckboxSelected: onCheckboxSelectedWrapper,
                      onOnToggleDisplayHeader: _cache[0] || (_cache[0] = (key, isHide) => {_unref(onToggleDisplayHeader)(_ctx.propTableType, key, _ctx.propTableContentProperties.contentProperties, isHide)}),
                      onOnCheckboxSelectedBusinessId: _cache[1] || (_cache[1] = ($event: any) => (onCheckboxSelectedBusinessId('', !_unref(state).isAllSelected, _unref(state).isAllSelected))),
                      onOnToggleHeaderModifyButtonMenu: _cache[2] || (_cache[2] = 
                  (isOpen) => {
                    _unref(state).isOpenHeaderModifyButtonMenu = isOpen;
                  }
                )
                    }, null, 8, ["header", "header-index", "accumulation-table-content-width", "is-variable-width", "stable-column-count", "is-editing", "is-bold", "is-all-selected", "modifiable-header-list", "is-open-header-modify-button-menu", "table-type"]))
                  : _createCommentVNode("", true),
                (_unref(isUniqueHeaderKey)(header.key))
                  ? (_openBlock(), _createBlock(UniqueTableHead, {
                      key: 1,
                      header: header,
                      "header-key": header.key,
                      "header-index": headerIndex,
                      "accumulation-table-content-width": _unref(state).accumulationTableContentWidth[headerIndex],
                      "is-variable-width": header.isVariableWidth,
                      "is-all-selected": _unref(state).isAllSelected,
                      "stable-column-count": _unref(state).tableContentProperties.options.stableColumnCount,
                      onOnClickSort: sortTableContentItemsWrapper,
                      onOnMousedownResizer: onMouseDownResizer
                    }, null, 8, ["header", "header-key", "header-index", "accumulation-table-content-width", "is-variable-width", "is-all-selected", "stable-column-count"]))
                  : _createCommentVNode("", true),
                (_unref(isOrderHeaderKey)(header.key))
                  ? (_openBlock(), _createBlock(OrderTableHead, {
                      key: 2,
                      class: _normalizeClass([
                  _unref(baseTableContentVM).isSticky(_unref(state).tableContentProperties.options.stableColumnCount, headerIndex) ? 'sticky-content' : '',
                ]),
                      style: _normalizeStyle({
                  left: _unref(baseTableContentVM).calcStickyDiff(
                    _unref(state).tableContentProperties.options.stableColumnCount,
                    headerIndex,
                    _unref(state).accumulationTableContentWidth[headerIndex]
                  ),
                }),
                      header: header,
                      "header-index": headerIndex,
                      "accumulation-table-content-width": _unref(state).accumulationTableContentWidth[headerIndex],
                      "is-variable-width": header.isVariableWidth,
                      "is-all-selected": _unref(state).isAllSelected,
                      "stable-column-count": _unref(state).tableContentProperties.options.stableColumnCount,
                      "is-order-group-edit-mode": props.propIsEditing,
                      "is-editing": !!props.propEditingId,
                      "editing-id": props.propEditingId,
                      onOnClickSort: sortTableContentItemsWrapper,
                      onOnMousedownResizer: onMouseDownResizer
                    }, null, 8, ["class", "style", "header", "header-index", "accumulation-table-content-width", "is-variable-width", "is-all-selected", "stable-column-count", "is-order-group-edit-mode", "is-editing", "editing-id"]))
                  : _createCommentVNode("", true),
                (_unref(isOrderControlHeaderKey)(header.key))
                  ? (_openBlock(), _createBlock(OrderControlTableHead, {
                      key: 3,
                      class: _normalizeClass([
                  _unref(baseTableContentVM).isSticky(_unref(state).tableContentProperties.options.stableColumnCount, headerIndex) ? 'sticky-content' : '',
                ]),
                      style: _normalizeStyle({
                  left: _unref(baseTableContentVM).calcStickyDiff(
                    _unref(state).tableContentProperties.options.stableColumnCount,
                    headerIndex,
                    _unref(state).accumulationTableContentWidth[headerIndex]
                  ),
                }),
                      header: header,
                      "header-index": headerIndex,
                      "accumulation-table-content-width": _unref(state).accumulationTableContentWidth[headerIndex],
                      "is-variable-width": header.isVariableWidth,
                      "is-all-selected": _unref(state).isAllSelected,
                      "stable-column-count": _unref(state).tableContentProperties.options.stableColumnCount,
                      "is-editing": _unref(state).isEditing,
                      onOnClickSort: sortTableContentItemsWrapper,
                      onOnMousedownResizer: onMouseDownResizer,
                      onOnCheckboxSelected: onCheckboxSelectedWrapperForOrderControl
                    }, null, 8, ["class", "style", "header", "header-index", "accumulation-table-content-width", "is-variable-width", "is-all-selected", "stable-column-count", "is-editing"]))
                  : _createCommentVNode("", true),
                (_unref(isForecastForReceiptKey)(header.key))
                  ? (_openBlock(), _createBlock(CustomerForecastTableHeaderWrapper, {
                      key: 4,
                      class: _normalizeClass([
                  _unref(baseTableContentVM).isSticky(_unref(state).tableContentProperties.options.stableColumnCount, headerIndex) ? 'sticky-content' : '',
                ]),
                      style: _normalizeStyle({
                  left: _unref(baseTableContentVM).calcStickyDiff(
                    _unref(state).tableContentProperties.options.stableColumnCount,
                    headerIndex,
                    _unref(state).accumulationTableContentWidth[headerIndex]
                  ),
                }),
                      header: header,
                      "header-index": headerIndex,
                      "accumulation-table-content-width": _unref(state).accumulationTableContentWidth[headerIndex],
                      "is-variable-width": header.isVariableWidth,
                      "is-all-selected": _unref(state).isAllSelected,
                      "stable-column-count": _unref(state).tableContentProperties.options.stableColumnCount,
                      "forecast-start-year-month": _unref(state).tableContentProperties.forecastStartYearMonth,
                      onOnClickSort: sortTableContentItemsWrapper,
                      onOnMousedownResizer: onMouseDownResizer
                    }, null, 8, ["class", "style", "header", "header-index", "accumulation-table-content-width", "is-variable-width", "is-all-selected", "stable-column-count", "forecast-start-year-month"]))
                  : _createCommentVNode("", true),
                (_unref(isForecastAccuracyKey)(header.key))
                  ? (_openBlock(), _createBlock(ForecastAccuracyTableHead, {
                      key: 5,
                      class: _normalizeClass([
                  _unref(baseTableContentVM).isSticky(_unref(state).tableContentProperties.options.stableColumnCount, headerIndex) ? 'sticky-content' : '',
                ]),
                      style: _normalizeStyle({
                  left: _unref(baseTableContentVM).calcStickyDiff(
                    _unref(state).tableContentProperties.options.stableColumnCount,
                    headerIndex,
                    _unref(state).accumulationTableContentWidth[headerIndex]
                  ),
                }),
                      header: header,
                      "header-index": headerIndex,
                      "accumulation-table-content-width": _unref(state).accumulationTableContentWidth[headerIndex],
                      "is-variable-width": header.isVariableWidth,
                      "is-all-selected": _unref(state).isAllSelected,
                      "stable-column-count": _unref(state).tableContentProperties.options.stableColumnCount,
                      "forecast-start-year-month": _unref(state).tableContentProperties.forecastStartYearMonth,
                      onOnClickSort: sortTableContentItemsWrapper,
                      onOnMousedownResizer: onMouseDownResizer
                    }, null, 8, ["class", "style", "header", "header-index", "accumulation-table-content-width", "is-variable-width", "is-all-selected", "stable-column-count", "forecast-start-year-month"]))
                  : _createCommentVNode("", true),
                (_unref(isUnmanagedBusinessHeaderKey)(header.key))
                  ? (_openBlock(), _createBlock(UnmanagedBusinessTableHead, {
                      key: 6,
                      class: _normalizeClass([
                  _unref(baseTableContentVM).isSticky(_unref(state).tableContentProperties.options.stableColumnCount, headerIndex) ? 'sticky-content' : '',
                ]),
                      style: _normalizeStyle({
                  left: _unref(baseTableContentVM).calcStickyDiff(
                    _unref(state).tableContentProperties.options.stableColumnCount,
                    headerIndex,
                    _unref(state).accumulationTableContentWidth[headerIndex]
                  ),
                }),
                      header: header,
                      "header-index": headerIndex,
                      "accumulation-table-content-width": _unref(state).accumulationTableContentWidth[headerIndex],
                      "is-variable-width": header.isVariableWidth,
                      "is-all-selected": _unref(state).isAllSelected,
                      "stable-column-count": _unref(state).tableContentProperties.options.stableColumnCount,
                      onOnClickSort: sortTableContentItemsWrapper,
                      onOnMousedownResizer: onMouseDownResizer
                    }, null, 8, ["class", "style", "header", "header-index", "accumulation-table-content-width", "is-variable-width", "is-all-selected", "stable-column-count"]))
                  : _createCommentVNode("", true),
                (_unref(isBusinessesForSupplierForecastHeaderKey)(header.key))
                  ? (_openBlock(), _createBlock(BusinessesForSupplierForecastTableHead, {
                      key: 7,
                      class: _normalizeClass([
                  _unref(baseTableContentVM).isSticky(_unref(state).tableContentProperties.options.stableColumnCount, headerIndex) ? 'sticky-content' : '',
                ]),
                      style: _normalizeStyle({
                  left: _unref(baseTableContentVM).calcStickyDiff(
                    _unref(state).tableContentProperties.options.stableColumnCount,
                    headerIndex,
                    _unref(state).accumulationTableContentWidth[headerIndex]
                  ),
                }),
                      header: header,
                      "header-index": headerIndex,
                      "accumulation-table-content-width": _unref(state).accumulationTableContentWidth[headerIndex],
                      "is-variable-width": header.isVariableWidth,
                      "is-all-selected": _unref(state).isAllSelected,
                      "stable-column-count": _unref(state).tableContentProperties.options.stableColumnCount,
                      "forecast-start-year-month": _unref(state).tableContentProperties.forecastStartYearMonth,
                      onOnClickSort: sortTableContentItemsWrapper,
                      onOnMousedownResizer: onMouseDownResizer
                    }, null, 8, ["class", "style", "header", "header-index", "accumulation-table-content-width", "is-variable-width", "is-all-selected", "stable-column-count", "forecast-start-year-month"]))
                  : _createCommentVNode("", true),
                (_unref(isTrashBinHeaderKey)(header.key))
                  ? (_openBlock(), _createBlock(TrashBinTableHead, {
                      key: 8,
                      class: _normalizeClass([
                  _unref(baseTableContentVM).isSticky(_unref(state).tableContentProperties.options.stableColumnCount, headerIndex) ? 'sticky-content' : '',
                ]),
                      style: _normalizeStyle({
                  left: _unref(baseTableContentVM).calcStickyDiff(
                    _unref(state).tableContentProperties.options.stableColumnCount,
                    headerIndex,
                    _unref(state).accumulationTableContentWidth[headerIndex]
                  ),
                }),
                      header: header,
                      "header-index": headerIndex,
                      "accumulation-table-content-width": _unref(state).accumulationTableContentWidth[headerIndex],
                      "is-variable-width": header.isVariableWidth,
                      "is-all-selected": _unref(state).isAllSelected,
                      "stable-column-count": _unref(state).tableContentProperties.options.stableColumnCount,
                      "forecast-start-year-month": _unref(state).tableContentProperties.forecastStartYearMonth,
                      onOnClickSort: sortTableContentItemsWrapper,
                      onOnMousedownResizer: onMouseDownResizer,
                      onOnCheckboxSelected: onCheckboxSelectedWrapper
                    }, null, 8, ["class", "style", "header", "header-index", "accumulation-table-content-width", "is-variable-width", "is-all-selected", "stable-column-count", "forecast-start-year-month"]))
                  : _createCommentVNode("", true),
                (_unref(isMoveWareHouseHeaderKey)(header.key))
                  ? (_openBlock(), _createBlock(CommonTableHead, {
                      key: headerIndex,
                      header: header,
                      "header-index": headerIndex,
                      "accumulation-table-content-width": _unref(state).accumulationTableContentWidth,
                      "is-variable-width": header.isVariableWidth,
                      "stable-column-count": _unref(state).tableContentProperties.options.stableColumnCount,
                      "is-editing": _unref(state).isEditing,
                      "is-bold": _unref(baseTableContentVM).isBold(_unref(state).narrowStates, header?.propertyPath?.paths),
                      "is-all-selected": _unref(state).isAllSelected,
                      "modifiable-header-list": _unref(getModifiableHeaderList)(_ctx.propTableType, _ctx.propTableContentProperties),
                      "is-open-header-modify-button-menu": _unref(state).isOpenHeaderModifyButtonMenu,
                      "table-type": _ctx.propTableType,
                      onOnClickSort: sortTableContentItemsWrapper,
                      onOnMousedownResizer: onMouseDownResizer,
                      onOnCheckboxSelected: onCheckboxSelectedWrapper,
                      onOnToggleDisplayHeader: _cache[3] || (_cache[3] = (key, isHide) => {_unref(onToggleDisplayHeader)(_ctx.propTableType, key, _ctx.propTableContentProperties.contentProperties, isHide)}),
                      onOnToggleHeaderModifyButtonMenu: _cache[4] || (_cache[4] = 
                  (isOpen) => {
                    _unref(state).isOpenHeaderModifyButtonMenu = isOpen;
                  }
                )
                    }, null, 8, ["header", "header-index", "accumulation-table-content-width", "is-variable-width", "stable-column-count", "is-editing", "is-bold", "is-all-selected", "modifiable-header-list", "is-open-header-modify-button-menu", "table-type"]))
                  : _createCommentVNode("", true)
              ], 64))
            }), 128))
          ], 4)
        ]),
        _createElementVNode("tbody", null, [
          (_unref(isLoading)(_unref(state).loadingState.status))
            ? (_openBlock(), _createElementBlock("tr", _hoisted_3, [
                _createElementVNode("td", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    (_unref(isLoading)(_unref(state).loadingState.status))
                      ? (_openBlock(), _createBlock(_unref(LottieAnimation), {
                          key: 0,
                          ref: "anim",
                          "animation-data": _unref(loadingAnimation),
                          "auto-play": true,
                          loop: true,
                          speed: 1
                        }, null, 8, ["animation-data"]))
                      : (_openBlock(), _createBlock(SvgLoader, {
                          key: 1,
                          class: _normalizeClass(`modal__icon`),
                          name: ""
                        })),
                    _createElementVNode("h1", _hoisted_6, _toDisplayString(_unref(t)('データを読み込んでいます')), 1)
                  ])
                ])
              ]))
            : (_unref(isZeroMatch)(_unref(state).loadingState.status))
              ? (_openBlock(), _createElementBlock("tr", _hoisted_7, [
                  _createElementVNode("td", _hoisted_8, _toDisplayString(_unref(t)('該当する取引はありません。')), 1)
                ]))
              : (_unref(isError)(_unref(state).loadingState.status))
                ? (_openBlock(), _createElementBlock("tr", _hoisted_9, [
                    _createElementVNode("td", _hoisted_10, [
                      _createTextVNode(_toDisplayString(_unref(t)('情報取得に失敗しました。時間を置いて再施行してください。')) + " ", 1),
                      _createElementVNode("button", {
                        class: "error__button",
                        onClick: _cache[5] || (_cache[5] = () => emits('reload'))
                      }, _toDisplayString(_unref(t)('再読込')), 1)
                    ])
                  ]))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                    (_unref(state).isAllSelected && _ctx.propTableType === 'trash')
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_11, [
                          _createElementVNode("td", _hoisted_12, [
                            _createElementVNode("div", null, _toDisplayString(_unref(t)('このページ内の取引全てが選択されています。')), 1),
                            _createElementVNode("button", {
                              class: "trash-bin-all-selected__button",
                              onClick: _cache[6] || (_cache[6] = ($event: any) => (emits('onClickTrashBinAllSelect')))
                            }, _toDisplayString(_unref(t)('取引')) + _toDisplayString(_ctx.propAllOfResult) + _toDisplayString(_unref(t)('件全て選択する')), 1)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(useItems.value, (item, itemIndex) => {
                      return (_openBlock(), _createElementBlock(_Fragment, {
                        key: `${_ctx.propTableType}-content-` + itemIndex
                      }, [
                        _createElementVNode("tr", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(useTableHeader.value, (header, headerIndex) => {
                            return (_openBlock(), _createElementBlock(_Fragment, {
                              key: _ctx.propTableType + header + headerIndex
                            }, [
                              (_unref(isCommonTableHeaderKey)(header.key))
                                ? (_openBlock(), _createBlock(CommonTableCell, {
                                    key: 0,
                                    header: header,
                                    "header-index": headerIndex,
                                    "accumulation-table-content-width": _unref(state).accumulationTableContentWidth,
                                    "stable-column-count": _unref(state).tableContentProperties.options.stableColumnCount,
                                    item: item,
                                    "is-editing": _unref(state).isEditing,
                                    "is-bold": _unref(baseTableContentVM).isBold(_unref(state).narrowStates, header?.propertyPath?.paths),
                                    "is-checked": _unref(state).selectedIds.includes(item?.displayId),
                                    "is-checked-business-id": isCheckedBusinessId(item),
                                    "selected-ids": _unref(state).selectedIds,
                                    "narrow-states": _unref(state).narrowStates,
                                    "is-expanded": false,
                                    "table-type": _ctx.propTableType,
                                    onOnCheckboxSelected: onCheckboxSelectedWrapper,
                                    onOnCheckboxSelectedBusinessId: onCheckboxSelectedBusinessId,
                                    onSetNarrowState: ($event: any) => (setNarrowStateWrapper(header, item?.[header.key]))
                                  }, null, 8, ["header", "header-index", "accumulation-table-content-width", "stable-column-count", "item", "is-editing", "is-bold", "is-checked", "is-checked-business-id", "selected-ids", "narrow-states", "table-type", "onSetNarrowState"]))
                                : _createCommentVNode("", true),
                              (_unref(isUniqueHeaderKey)(header.key))
                                ? (_openBlock(), _createBlock(UniqueTableCell, {
                                    key: 1,
                                    header: header,
                                    "header-key": header.key,
                                    item: item,
                                    "header-index": headerIndex,
                                    "accumulation-table-content-width": _unref(state).accumulationTableContentWidth[headerIndex],
                                    "is-variable-width": header.isVariableWidth,
                                    "is-all-selected": _unref(state).isAllSelected,
                                    "stable-column-count": _unref(state).tableContentProperties.options.stableColumnCount,
                                    "is-editing": _unref(state).isEditing,
                                    "is-bold": _unref(baseTableContentVM).isBold(_unref(state).narrowStates, header?.propertyPath?.paths),
                                    "is-checked": _unref(state).selectedIds.includes(item?.displayId),
                                    "is-checked-business-id": isCheckedBusinessId(item),
                                    onOnClickNarrow: ($event: any) => (setNarrowStateWrapper(header, item?.[header.key]))
                                  }, null, 8, ["header", "header-key", "item", "header-index", "accumulation-table-content-width", "is-variable-width", "is-all-selected", "stable-column-count", "is-editing", "is-bold", "is-checked", "is-checked-business-id", "onOnClickNarrow"]))
                                : _createCommentVNode("", true),
                              (_unref(isOrderHeaderKey)(header.key))
                                ? (_openBlock(), _createBlock(OrderTableCell, {
                                    key: 2,
                                    header: header,
                                    "order-header-key": header.key,
                                    item: item,
                                    "header-index": headerIndex,
                                    "item-index": itemIndex,
                                    "accumulation-table-content-width": _unref(state).accumulationTableContentWidth[headerIndex],
                                    "is-variable-width": header.isVariableWidth,
                                    "is-all-selected": _unref(state).isAllSelected,
                                    "stable-column-count": _unref(state).tableContentProperties.options.stableColumnCount,
                                    "is-bold": _unref(baseTableContentVM).isBold(_unref(state).narrowStates, header?.propertyPath?.paths),
                                    "is-alert-opening": itemIndex.toString() === _unref(state).isOpeningAlertIndex,
                                    "editing-id": props.propEditingId,
                                    "is-checked": _unref(state).selectedIds.includes(item?.displayId),
                                    "is-checked-business-id": isCheckedBusinessId(item),
                                    "is-order-group-edit-mode": props.propIsEditing,
                                    onChangeEditableValue: (headerKey, value) => emits('onChangeOrderProperty', item?.orderId, headerKey, value),
                                    onOnClickNarrow: ($event: any) => (setNarrowStateWrapper(header, item?.[header.key])),
                                    onClickAlert: 
                      () => {
                        _unref(state).isOpeningAlertIndex = itemIndex.toString();
                      }
                    ,
                                    onOnClickEdit: _cache[7] || (_cache[7] = ($event: any) => (emits('onClickEdit', $event))),
                                    onOnClickSave: _cache[8] || (_cache[8] = ($event: any) => (emits('onClickSave', $event))),
                                    onOnClickSaveMemo: _cache[9] || (_cache[9] = (id, memoText) => emits('onClickSaveMemo', id, memoText)),
                                    onOnClickDeleteMemo: _cache[10] || (_cache[10] = ($event: any) => (emits('onClickDeleteMemo', $event))),
                                    onOnClickReminderMail: _cache[11] || (_cache[11] = ($event: any) => (emits('onClickReminderMail', $event))),
                                    onOnClickOrderBasis: _cache[12] || (_cache[12] = ($event: any) => (emits('onClickOrderBasis', $event)))
                                  }, null, 8, ["header", "order-header-key", "item", "header-index", "item-index", "accumulation-table-content-width", "is-variable-width", "is-all-selected", "stable-column-count", "is-bold", "is-alert-opening", "editing-id", "is-checked", "is-checked-business-id", "is-order-group-edit-mode", "onChangeEditableValue", "onOnClickNarrow", "onClickAlert"]))
                                : _createCommentVNode("", true),
                              (_unref(isOrderControlHeaderKey)(header.key))
                                ? (_openBlock(), _createBlock(OrderControlTableCell, {
                                    key: 3,
                                    header: header,
                                    "order-control-header-key": header.key,
                                    item: item,
                                    "header-index": headerIndex,
                                    "accumulation-table-content-width": _unref(state).accumulationTableContentWidth[headerIndex],
                                    "is-variable-width": header.isVariableWidth,
                                    "is-all-selected": _unref(state).isAllSelected,
                                    "stable-column-count": _unref(state).tableContentProperties.options.stableColumnCount,
                                    "is-bold": _unref(baseTableContentVM).isBold(_unref(state).narrowStates, header?.propertyPath?.paths),
                                    "is-editing": _unref(state).isEditing,
                                    "is-checked": _unref(state).selectedIds.includes(item?.displayId),
                                    "is-checked-business-id": isCheckedBusinessId(item),
                                    onOnClickNarrow: ($event: any) => (setNarrowStateWrapper(header, item?.[header.key])),
                                    onOnCheckboxSelected: onCheckboxSelectedWrapperForOrderControl
                                  }, null, 8, ["header", "order-control-header-key", "item", "header-index", "accumulation-table-content-width", "is-variable-width", "is-all-selected", "stable-column-count", "is-bold", "is-editing", "is-checked", "is-checked-business-id", "onOnClickNarrow"]))
                                : _createCommentVNode("", true),
                              (_unref(isForecastForReceiptKey)(header.key))
                                ? (_openBlock(), _createBlock(CustomerForecastTableCellWrapper, {
                                    key: 4,
                                    header: header,
                                    "header-key": header.key,
                                    item: item,
                                    "header-index": headerIndex,
                                    "accumulation-table-content-width": _unref(state).accumulationTableContentWidth[headerIndex],
                                    "is-variable-width": header.isVariableWidth,
                                    "is-all-selected": _unref(state).isAllSelected,
                                    "stable-column-count": _unref(state).tableContentProperties.options.stableColumnCount,
                                    "is-bold": _unref(baseTableContentVM).isBold(_unref(state).narrowStates, header?.propertyPath?.paths),
                                    "forecast-start-year-month": _unref(state).tableContentProperties.forecastStartYearMonth,
                                    "is-checked": _unref(state).selectedIds.includes(item?.displayId),
                                    "is-checked-business-id": isCheckedBusinessId(item),
                                    onOnClickNarrow: ($event: any) => (setNarrowStateWrapper(header, item?.[header.key])),
                                    onOnClickTransitionTimeline: ($event: any) => (emits('onClickTransitionTimeline', item?.displayId)),
                                    onOnClickTransactionList: ($event: any) => (emits('onClickTransactionList', item?.displayId)),
                                    onOnClickDownload: ($event: any) => (emits('onClickDownload', item?.displayId)),
                                    onOnClickForecastRequestMail: ($event: any) => (emits('onClickForecastRequestMail', item?.displayId)),
                                    onOnClickEdit: ($event: any) => (emits('onClickEdit', item?.displayId)),
                                    onOnClickRemoveFromForecast: ($event: any) => (emits('onClickRemoveFromForecast', item?.displayId))
                                  }, null, 8, ["header", "header-key", "item", "header-index", "accumulation-table-content-width", "is-variable-width", "is-all-selected", "stable-column-count", "is-bold", "forecast-start-year-month", "is-checked", "is-checked-business-id", "onOnClickNarrow", "onOnClickTransitionTimeline", "onOnClickTransactionList", "onOnClickDownload", "onOnClickForecastRequestMail", "onOnClickEdit", "onOnClickRemoveFromForecast"]))
                                : _createCommentVNode("", true),
                              (_unref(isForecastAccuracyKey)(header.key))
                                ? (_openBlock(), _createBlock(ForecastAccuracyTableCell, {
                                    key: 5,
                                    header: header,
                                    "header-key": header.key,
                                    item: item,
                                    "header-index": headerIndex,
                                    "accumulation-table-content-width": _unref(state).accumulationTableContentWidth[headerIndex],
                                    "is-variable-width": header.isVariableWidth,
                                    "is-all-selected": _unref(state).isAllSelected,
                                    "stable-column-count": _unref(state).tableContentProperties.options.stableColumnCount,
                                    "is-bold": _unref(baseTableContentVM).isBold(_unref(state).narrowStates, header?.propertyPath?.paths),
                                    "forecast-start-year-month": _unref(state).tableContentProperties.forecastStartYearMonth,
                                    "is-checked": _unref(state).selectedIds.includes(item?.displayId),
                                    "is-checked-business-id": isCheckedBusinessId(item),
                                    onOnClickNarrow: ($event: any) => (setNarrowStateWrapper(header, item?.[header.key])),
                                    onOnClickDownload: _cache[13] || (_cache[13] = (displayId) => emits('onClickDownload', displayId))
                                  }, null, 8, ["header", "header-key", "item", "header-index", "accumulation-table-content-width", "is-variable-width", "is-all-selected", "stable-column-count", "is-bold", "forecast-start-year-month", "is-checked", "is-checked-business-id", "onOnClickNarrow"]))
                                : _createCommentVNode("", true),
                              (_unref(isUnmanagedBusinessHeaderKey)(header.key))
                                ? (_openBlock(), _createBlock(UnmanagedBusinessTableCell, {
                                    key: 6,
                                    header: header,
                                    "unmanged-business-header-key": header.key,
                                    item: item,
                                    "header-index": headerIndex,
                                    "accumulation-table-content-width": _unref(state).accumulationTableContentWidth[headerIndex],
                                    "is-variable-width": header.isVariableWidth,
                                    "is-all-selected": _unref(state).isAllSelected,
                                    "stable-column-count": _unref(state).tableContentProperties.options.stableColumnCount,
                                    "is-editing": _unref(state).isEditing,
                                    "is-bold": _unref(baseTableContentVM).isBold(_unref(state).narrowStates, header?.propertyPath?.paths),
                                    "is-checked": _unref(state).selectedIds.includes(item?.displayId),
                                    "is-checked-business-id": isCheckedBusinessId(item),
                                    onOnClickNarrow: ($event: any) => (setNarrowStateWrapper(header, item?.[header.key]))
                                  }, null, 8, ["header", "unmanged-business-header-key", "item", "header-index", "accumulation-table-content-width", "is-variable-width", "is-all-selected", "stable-column-count", "is-editing", "is-bold", "is-checked", "is-checked-business-id", "onOnClickNarrow"]))
                                : _createCommentVNode("", true),
                              (_unref(isBusinessesForSupplierForecastHeaderKey)(header.key))
                                ? (_openBlock(), _createBlock(BusinessesForSupplierForecastTableCell, {
                                    key: 7,
                                    header: header,
                                    "header-key": header.key,
                                    item: item,
                                    "header-index": headerIndex,
                                    "accumulation-table-content-width": _unref(state).accumulationTableContentWidth[headerIndex],
                                    "is-variable-width": header.isVariableWidth,
                                    "is-all-selected": _unref(state).isAllSelected,
                                    "stable-column-count": _unref(state).tableContentProperties.options.stableColumnCount,
                                    "is-bold": _unref(baseTableContentVM).isBold(_unref(state).narrowStates, header?.propertyPath?.paths),
                                    "forecast-start-year-month": _unref(state).tableContentProperties.forecastStartYearMonth,
                                    "is-checked": _unref(state).selectedIds.includes(item?.displayId),
                                    "is-checked-business-id": isCheckedBusinessId(item),
                                    onOnClickNarrow: ($event: any) => (setNarrowStateWrapper(header, item?.[header.key]))
                                  }, null, 8, ["header", "header-key", "item", "header-index", "accumulation-table-content-width", "is-variable-width", "is-all-selected", "stable-column-count", "is-bold", "forecast-start-year-month", "is-checked", "is-checked-business-id", "onOnClickNarrow"]))
                                : _createCommentVNode("", true),
                              (_unref(isTrashBinHeaderKey)(header.key))
                                ? (_openBlock(), _createBlock(TrashBinTableCell, {
                                    key: 8,
                                    header: header,
                                    "trash-bin-header-key": header.key,
                                    item: item,
                                    "header-index": headerIndex,
                                    "accumulation-table-content-width": _unref(state).accumulationTableContentWidth[headerIndex],
                                    "is-all-selected": _unref(state).isAllSelected,
                                    "stable-column-count": _unref(state).tableContentProperties.options.stableColumnCount,
                                    "is-checked": _unref(state).selectedIds.includes(item?.displayId),
                                    "is-checked-business-id": isCheckedBusinessId(item),
                                    onOnClickNarrow: ($event: any) => (setNarrowStateWrapper(header, item?.[header.key])),
                                    onOnCheckboxSelected: onCheckboxSelectedWrapper
                                  }, null, 8, ["header", "trash-bin-header-key", "item", "header-index", "accumulation-table-content-width", "is-all-selected", "stable-column-count", "is-checked", "is-checked-business-id", "onOnClickNarrow"]))
                                : _createCommentVNode("", true),
                              (_unref(isMoveWareHouseHeaderKey)(header.key))
                                ? (_openBlock(), _createBlock(MoveWarehouseTableCell, {
                                    key: 9,
                                    header: header,
                                    "move-warehouse-header-key": header.key,
                                    item: item,
                                    "header-index": headerIndex,
                                    "accumulation-table-content-width": _unref(state).accumulationTableContentWidth[headerIndex],
                                    "is-variable-width": header.isVariableWidth,
                                    "is-all-selected": _unref(state).isAllSelected,
                                    "stable-column-count": _unref(state).tableContentProperties.options.stableColumnCount,
                                    "is-editing": _unref(state).isEditing,
                                    "is-bold": _unref(baseTableContentVM).isBold(_unref(state).narrowStates, header?.propertyPath?.paths),
                                    "is-checked": _unref(state).selectedIds.includes(item?.displayId),
                                    "is-checked-business-id": isCheckedBusinessId(item),
                                    onOnClickNarrow: ($event: any) => (setNarrowStateWrapper(header, item?.[header.key]))
                                  }, null, 8, ["header", "move-warehouse-header-key", "item", "header-index", "accumulation-table-content-width", "is-variable-width", "is-all-selected", "stable-column-count", "is-editing", "is-bold", "is-checked", "is-checked-business-id", "onOnClickNarrow"]))
                                : _createCommentVNode("", true)
                            ], 64))
                          }), 128))
                        ]),
                        (hasPartialDelivery(item))
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.partialDeliveries, (partialDelivery, partialDeliveryIndex) => {
                                return (_openBlock(), _createElementBlock("tr", {
                                  key: `${itemIndex}-${partialDeliveryIndex}`
                                }, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(useTableHeader.value, (header, headerIndex) => {
                                    return (_openBlock(), _createElementBlock(_Fragment, {
                                      key: _ctx.propTableType + header + headerIndex + itemIndex + partialDeliveryIndex
                                    }, [
                                      (_unref(isOrderHeaderKey)(header.key))
                                        ? (_openBlock(), _createBlock(OrderTableCell, {
                                            key: 0,
                                            "is-partial-delivery": "",
                                            header: header,
                                            "order-header-key": header.key,
                                            item: partialDelivery,
                                            "header-index": headerIndex,
                                            "item-index": partialDeliveryIndex,
                                            "accumulation-table-content-width": _unref(state).accumulationTableContentWidth[headerIndex],
                                            "is-variable-width": header.isVariableWidth,
                                            "is-all-selected": _unref(state).isAllSelected,
                                            "stable-column-count": _unref(state).tableContentProperties.options.stableColumnCount,
                                            "is-bold": _unref(baseTableContentVM).isBold(_unref(state).narrowStates, header?.propertyPath?.paths),
                                            "is-alert-opening": partialDeliveryIndex.toString() === _unref(state).isOpeningAlertIndex,
                                            "editing-id": props.propEditingId,
                                            "is-checked": _unref(state).selectedIds.includes(item?.displayId),
                                            "is-checked-business-id": _unref(state).selectedIds.includes(item?.businessId),
                                            onChangeEditableValue: 
                          (headerKey, value) => emits('onChangePartialDelivery', item.orderId, partialDelivery.id, headerKey, value)
                        ,
                                            onOnClickNarrow: ($event: any) => (setNarrowStateWrapper(header, partialDelivery?.[header.key])),
                                            onClickAlert: 
                          () => {
                            _unref(state).isOpeningAlertIndex = partialDeliveryIndex.toString();
                          }
                        ,
                                            onOnClickEdit: _cache[14] || (_cache[14] = ($event: any) => (emits('onClickEdit', $event))),
                                            onOnClickSave: _cache[15] || (_cache[15] = ($event: any) => (emits('onClickSave', $event))),
                                            onOnClickDelete: ($event: any) => (emits('onClickDelete', item.orderId, partialDelivery.id))
                                          }, null, 8, ["header", "order-header-key", "item", "header-index", "item-index", "accumulation-table-content-width", "is-variable-width", "is-all-selected", "stable-column-count", "is-bold", "is-alert-opening", "editing-id", "is-checked", "is-checked-business-id", "onChangeEditableValue", "onOnClickNarrow", "onClickAlert", "onOnClickDelete"]))
                                        : (_openBlock(), _createBlock(TableCell, { key: 1 }))
                                    ], 64))
                                  }), 128))
                                ]))
                              }), 128)),
                              _withDirectives(_createElementVNode("tr", null, [
                                _createElementVNode("td", _hoisted_13, [
                                  _createElementVNode("div", _hoisted_14, [
                                    _createElementVNode("button", {
                                      class: "add-partial-delivery__button",
                                      onClick: _withModifiers(($event: any) => (emits('onClickAddPartialDelivery', item.orderId)), ["stop","prevent"])
                                    }, [
                                      _createTextVNode(_toDisplayString(_unref(t)('一行追加')), 1),
                                      _createVNode(SvgLoader, {
                                        class: "add-partial-delivery__button__icon",
                                        name: "plusButtonIcon"
                                      })
                                    ], 8, _hoisted_15)
                                  ])
                                ])
                              ], 512), [
                                [_vShow, item.partialDeliveries?.length > 0 && item.orderId === _ctx.propEditingId]
                              ])
                            ], 64))
                          : _createCommentVNode("", true)
                      ], 64))
                    }), 128))
                  ], 64))
        ])
      ], 8, _hoisted_1)
    ], undefined, true),
    _: 1
  }, 8, ["id"]))
}
}

})